import(/* webpackMode: "eager", webpackExports: ["ForgotPasswordClientPage"] */ "/opt/atlassian/pipelines/agent/build/apps/loyalty/app/[hostname]/(auth)/forgot-password/client.tsx");
